import React from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton' 
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux'; 
import { v4 as uuidv4 } from 'uuid';
import SelectSearch from '../../utils/Selectsearch/SelectSearch';
import SelectComp from '../../utils/Select/SelectComp';

const ConfParts = (props) => {
    const [formData,setFormData] = React.useState({
        partId: "",
        partName: "",
        length: 1,
        width: 1,
        height: 1,
        weight: 1,
        CBM: "",
        code: uuidv4(),
        status: "Active",
        stickerSize: "md"
    }); 
    const [err,setErr] = React.useState({partName: false,length: false,weight: false,code: false,width: false,height: false,stickerSize : false})

    const [loading,setLoading] = React.useState(false) 
    React.useEffect(() => {
        if(props.type == "EDIT") { 
            setFormData({...formData,...props.activePart,partId: props.activePart._id})
        } 
    },[props.activePart]); 
 

    const validate = () => {
        let validData = true;
        let error = {partName: false,length: false,weight: false,code: false,width: false,height: false,stickerSize: false}
        setErr({...err,...error});
        Object.keys(error).map(key => {
            if(formData[key] == "") {
                error[key] = "Field cannot be empty";
                validData = false
            }
        })
        setErr({...error});

        return validData;
    }
    // SUBMIT
    const onSubmit = () => {
        if(validate()) {
            setLoading(true);
            const url = props.type == "EDIT" ? "/editProductPart" : "/addProductPart"

            axios({
                method: "post",
                url: url,
                data: {
                    ...formData, 
                }
            })
            .then(res => {
                if(res.data.success) {
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    setFormData({partId: "",partName: "",length: "",width:"",height: "",weight: "",CBM: "",code: uuidv4(),status: "",stickerSize:""})
                } else {
                    setLoading(false);
                    props.setAlert("Something went wrong !Try Again")
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong !Try Again")
            })
        }
    }

    let btnText = props.type == "EDIT" ? "Update Part" : "Add Part";
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'md'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div>

                    <h2>Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Part Name"
                                value={formData.partName}
                                onBlur={(e) => setFormData({...formData,partName: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,partName: e.target.value})}
                                error={err.partName}
                                helperText={err.partName}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Code"
                                disabled 
                                value={formData.parts_barcode}
                                onChange={(e) => setFormData({...formData,code: e.target.value})}
                                error={err.code}
                                helperText={err.code}
                                disabled
                                
                            /> 
                        </div> 

                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Length"
                                type="number"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">Cm</InputAdornment>
                                }}
                                value={formData.length} 
                                onBlur={(e) => setFormData({...formData,length: e.target.value.trim()})}

                                onChange={(e) => setFormData({...formData,length: e.target.value})}
                                error={err.length}
                                helperText={err.length}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Width"
                                type="number"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">Cm</InputAdornment>
                                }}
                                value={formData.width} 
                                onBlur={(e) => setFormData({...formData,width: e.target.value.trim()})}

                                onChange={(e) => setFormData({...formData,width: e.target.value})}
                                error={err.width}
                                helperText={err.width}
                            />
                        </div> 

                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Height"
                                type="number"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">Cm</InputAdornment>
                                }}
                                value={formData.height} 
                                onBlur={(e) => setFormData({...formData,height: e.target.value.trim()})}

                                onChange={(e) => setFormData({...formData,height: e.target.value})}
                                error={err.height}
                                helperText={err.height}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Weight"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">Kg</InputAdornment>
                                }}
                                type="text"
                                value={formData.weight} 
                                onBlur={(e) => setFormData({...formData,weight: e.target.value.trim()})}

                                onChange={(e) => setFormData({...formData,weight: e.target.value})}
                                error={err.weight}
                                helperText={err.weight}
                            />
                        </div> 

                        <div className={styles.row}>
                            <SelectComp 
                                variant="outlined"
                                className={styles.textField}
                                label="Status"
                                value={formData.status} 
                                onChange={(e) => setFormData({...formData,status: e.target.value})}
                                options={["Active","Inactive"]}
                                values={["Active","Inactive"]}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="CBM"
                                value={parseInt(formData.length) * parseInt(formData.width) * parseInt(formData.height)} 
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">Cm <sup>3</sup></InputAdornment>
                                }}
                                disabled
                                // onChange={(e) => setFormData({...formData,CBM: e.target.value})}
                            />
                        </div> 
                        <div className={styles.row}>
                            <SelectComp
                                value={formData.stickerSize}
                                onChange={(e) => setFormData({...formData,stickerSize: e.target.value})}
                                label="Sticker Size"
                                variant="outlined"
                                className={styles.textField}
                                values={["Small","Medium","Large"]}
                                options={["Small","Medium","Large"]}
                            />
                        </div> 
                    </div>

                    <Divider />
 
                     
                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfParts);